import Getintouch from '../components/getintouch.js';
import Smb from '../components/smallbanner';

export default function Latestnews(){
    return (
        <div>
            <Smb />
            <h2 className="p-5">Latest News</h2>
            <Getintouch />
            
        </div>
    );
}